// This distinguishes requests to get company information between Supplier or Vendor.
export enum CompanyInformationSource {
  Supplier = 'supplier',
  Vendor = 'vendor',
}
